import React from 'react';
import AppRouter from "./router/router";

const App = () => {
    return (
        <AppRouter/>
    );
};
export default App;